export default __webpack_public_path__ + "static/media/ic_busd_24.98f2be50.svg";